"use client";

import React from "react";
import { ToastContainer } from "react-toastify";
import { useBreakpoint } from "@/hooks/useBreakpoint";
import { useNetworkStore } from "@/stores/networkStore";
import { onlineNotification } from "@/components/Notification/Types";
import styles from "./styles.module.scss";
export default function NetworkStatusNotification() {
  const {
    activatedBreakpoints
  } = useBreakpoint();
  const isMobileViewPort = activatedBreakpoints.indexOf("md") === -1;
  const {
    isOnline,
    setOnline
  } = useNetworkStore();

  // State variable to track if the component has mounted
  const [hasMounted, setHasMounted] = React.useState(false);

  // On initialization
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  React.useEffect(() => {
    if (hasMounted && isOnline) {
      onlineNotification();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline]);
  React.useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [setOnline]);
  return <ToastContainer className={isMobileViewPort ? styles.smToastContainer : styles.mdToastContainer} />;
}